module.exports = __webpack_public_path__ + "img/wip.71cfc2b7.png";